"use client";

// Packages
import React, { useState } from "react";
import classNames from "classnames";

type ToggleProps = {
  clickElement: React.ReactNode;
  children: React.ReactNode;
  clickClass: string;
  clickActiveClass: string;
  childClass: string;
  noToggleClass: string;
  buttonPosition?: string;
  isOpen?: boolean;
  onToggle?: () => void;
};

const Toggle = ({
  clickElement,
  clickClass,
  clickActiveClass,
  childClass,
  noToggleClass,
  buttonPosition = "top",
  children,
  isOpen,
  onToggle,
}: ToggleProps) => {
  const [internalToggle, setInternalToggle] = useState(false);
  const isControlled = onToggle !== undefined;
  const toggle = isControlled ? (isOpen ?? false) : internalToggle;

  const clickEvent = () => {
    if (isControlled) {
      onToggle();
    } else {
      setInternalToggle((current) => !current);
    }
  };

  const handleToggleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      clickEvent();
    }
  };

  return (
    <>
      {buttonPosition == "top" && (
        <span
          role="button"
          tabIndex={0}
          onClick={clickEvent}
          onKeyDown={handleToggleKeyDown}
          className={classNames({ [clickActiveClass]: toggle }, clickClass)}
        >
          {clickElement}
        </span>
      )}
      <div
        className={classNames([
          { collapsed: !toggle, [noToggleClass]: noToggleClass != "" },
          { [childClass]: !toggle },
        ])}
      >
        {children}
      </div>
      {buttonPosition == "bottom" && (
        <span
          role="button"
          tabIndex={0}
          onClick={clickEvent}
          onKeyDown={handleToggleKeyDown}
          className={classNames({ [clickActiveClass]: toggle }, clickClass)}
        >
          {clickElement}
        </span>
      )}
    </>
  );
};

export default Toggle;
